import dayjs, { Dayjs } from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

// parse a TZ-less datetime string (e.g. "2026-05-25T00:00:00.000") that is
// meant to be in the partner's timezone, not the viewer's. Some
// Provision tables (e.g. `partner_holiday`) store timestamps as `timestamp
// without time zone` whose intended TZ is the partner's. Plain
// `dayjs(value)` parses naked strings in the viewer's local TZ, which
// silently corrupts cross-TZ reads (PS-team Memorial Day report). Use this
// helper at the consumption boundary to re-anchor those values.
export function parsePartnerDateTime(value: string, partnerTimezone: string): Dayjs {
  return dayjs.tz(value, partnerTimezone);
}
